import { createMuiTheme } from '@material-ui/core'

const caColour = '#6ac498'
// Calender is currently only used in CA (in the main repo, it's also used in markets),
// if we want use it in other sections we will need to update this to switch themes
// depending on the section it is used in
// See  https://material-ui-pickers.dev/guides/css-overrides for more options
export default createMuiTheme({
  overrides: {
    MuiPickersDay: {
      daySelected: {
        backgroundColor: caColour,
        '&:hover': {
          backgroundColor: caColour
        }
      },
      current: {
        color: caColour
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: caColour
      }
    },
    MuiPickersYear: {
      yearSelected: {
        color: caColour
      }
    },
    MuiPickersMonth: {
      monthSelected: {
        color: caColour
      }
    },
    MuiInputBase: {
      root: {
        cursor: 'pointer'
      },
      input: {
        cursor: 'pointer',
        userSelect: 'none'
      }
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: 'white',
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: caColour
        },
        '&$focused $notchedOutline': {
          borderColor: caColour
        }
      },
      notchedOutline: {
        borderColor: '#6288A5'
      }
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: caColour
        }
      }
    }
  }
})
